import { render, staticRenderFns } from "./shopHead.vue?vue&type=template&id=78430e31&scoped=true"
import script from "./shopHead.vue?vue&type=script&lang=js"
export * from "./shopHead.vue?vue&type=script&lang=js"
import style0 from "./shopHead.vue?vue&type=style&index=0&id=78430e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78430e31",
  null
  
)

export default component.exports